import "./polyfills";
import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");
// During react-snap prerender, backend fetches are blocked and some pages fire
// unhandled promise rejections. react-snap treats these as fatal pageerrors and
// aborts the whole prerender (dropping static HTML + JSON-LD for later pages).
// Suppress them ONLY while prerendering so every route gets its static HTML.
if (typeof navigator !== "undefined" && /ReactSnap/i.test(navigator.userAgent || "")) {
  window.addEventListener("unhandledrejection", (e) => e.preventDefault());
}
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// react-snap pre-renders the app to static HTML at build time. When the page
// loads in the browser, we hydrate it instead of re-rendering from scratch.
// This preserves SEO content for crawlers/LLMs while keeping the SPA fast.
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, tree);
} else {
  createRoot(rootEl).render(tree);
}
